import clsx from 'clsx'

import useCall from '~/hooks/useCall'

const TotalServe = () => {
  const { isQueueStarted, callData } = useCall()

  return (
    <div className={clsx('flex items-center justify-center rounded-lg bg-white p-4')}>
      {isQueueStarted ? (
        <div className="text-center text-xl font-bold text-jba-blue">
          <div className="mb-1 text-xs">Total Serve Ticket</div>
          <div className="text-xl font-black">{callData.done_list.length}</div>
        </div>
      ) : (
        <div className="flex h-[3rem] items-center justify-center text-gray-400">Antrean belum dimulai.</div>
      )}
    </div>
  )
}

export default TotalServe
